import EmptyProductLogo from '../../../../assets/images/emptyProductLogo.svg';

/**
 * Square product image for the new product modal.
 * Restaurants upload square photos by convention, so this component
 * just enforces a 1:1 ratio and clean rounded presentation.
 */
const ProductImage = ({ product, rounded = true }) => (
  <div
    className="relative w-full overflow-hidden"
    style={{
      aspectRatio: '1 / 1',
      background: 'var(--ui-line)',
      borderRadius: rounded ? '16px' : '0',
    }}
  >
    <img
      src={product.imagepath || EmptyProductLogo}
      alt={product.name}
      className="w-full h-full object-cover"
    />
  </div>
);

export default ProductImage;
